<template>
    <div class="elfinder-responsive">
        <div id="elfinderContract"></div>
    </div>
</template>

<script>

export default {
    name: "Contracts",
    data() {
        return {
        };
    },
    mounted() {
        $('#elfinderContract').elfinder({
            url: `${process.env.VUE_APP_API_URL}/elfinder/connector/contract`,
            customData: { type: 'contract' }, // 👈 phân biệt
            height: 500,
            resizable: false,
            requestType: 'post',
            rememberLastDir: false,
            handlers: {
                init: function (event, elfinderInstance) {
                    elfinderInstance.id = 'elfinderContract' // 👈 gán id riêng
                }
            },
            uiOptions : {
                toolbar : []
            }
        });
    },
    methods: {

    }
}
</script>

<style scoped>
.elfinder-responsive {
    width: 100%;
    min-width: 0;
    overflow-x: auto;
}

.elfinder-responsive /deep/ .elfinder {
    min-width: 720px;
}

@media (max-width: 575.98px) {
    .elfinder-responsive /deep/ .elfinder {
        min-width: 640px;
    }
}
</style>
